import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  variant?: 'check' | 'cross';
  className?: string;
};
export function CheckItem({
  children,
  variant = 'check',
  className = ''
}: CheckItemProps) {
  const isCheck = variant === 'check';
  return <li className={`flex items-start gap-3 ${className}`} data-id="element-20" data-mp="2c1o9u4fhh79c">
      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${isCheck ? 'bg-gold text-black' : 'border border-red-400/50 text-red-400'}`} data-id="element-21" data-mp="2c04wall7pab9">
        {isCheck ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-22" data-mp="1o4sech62gjkv" /> : <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-23" data-mp="1o6vdbqp75n1q" />}
      </span>
      <span data-id="element-24" data-mp="1t5ptslzoyzio">{children}</span>
    </li>;
}